import { Component, Input } from '@angular/core';

@Component({
    selector: 'sgt-sob-demanda-label',
    templateUrl: './sob-demanda-label.component.html',
    styleUrls: ['./sob-demanda-label.component.less']
})
export class SobDemandaLabelComponent {
    @Input() title = 'Sob Demanda'
    @Input() sobDemanda: boolean;
    @Input() fontSize = '12px';
}
